module.exports = __webpack_public_path__ + "static/img/fa6.d9fdcfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newWebSiteImg/pc/solution/fa6.png
// module id = HLrL
// module chunks = 3